// test926
(926 && 0);
